// Mock data for VV CosmoTech Manufacturing Landing Page

export const companyInfo = {
  name: "VV CosmoTech",
  parent: "Vijan Ventures LLP",
  tagline: "Turnkey Beauty Manufacturing Solutions",
  description: "Leading provider of comprehensive beauty and cosmetics manufacturing services, specializing in R&D, Private Labeling, Third Party Manufacturing, and Premium Packaging Solutions.",
  email: "info@vvcosmotech.com",
  phone: "+91 9653226520",
  address: "Andheri West, Mumbai, Maharashtra, India",
  workedWithRegions: ["India", "USA", "South Africa", "UAE"]
};

export const services = [
  {
    id: 1,
    title: "Research & Development",
    description: "Innovative formulations and cutting-edge product development with our state-of-the-art R&D facilities.",
    icon: "Microscope"
  },
  {
    id: 2,
    title: "Private Labeling",
    description: "Complete white-label solutions to launch your own beauty brand with our expertise and infrastructure.",
    icon: "Tag"
  },
  {
    id: 3,
    title: "Third Party Manufacturing",
    description: "End-to-end manufacturing services with stringent quality control and timely delivery.",
    icon: "Factory"
  },
  {
    id: 4,
    title: "Packaging Imports from China",
    description: "Premium quality packaging solutions sourced directly from trusted manufacturers in China.",
    icon: "Package"
  }
];

export const certifications = [
  "ISO 9001:2015 Certified",
  "FDA Approved Manufacturing",
  "Lab Tested Products"
];

export const productCategories = [
  {
    id: 1,
    name: "Hair Care",
    description: "Premium hair care solutions",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1624939461078-66a124b3539c",
    altText: "Professional hair care products manufacturing - hair serum and oil production India"
  },
  {
    id: 2,
    name: "Colour Cosmetics",
    description: "Vibrant and long-lasting makeup",
    icon: "Palette",
    image: "https://images.unsplash.com/photo-1659517175423-9e94aa553374",
    altText: "Colour cosmetics manufacturing India - lipstick, lip gloss, eyeshadow production"
  },
  {
    id: 3,
    name: "Skin Care",
    description: "Advanced skincare formulations",
    icon: "Droplets",
    image: "https://images.unsplash.com/photo-1613803745799-ba6c10aace85",
    altText: "Skincare products manufacturing - serums, moisturizers, face mist production India"
  },
  {
    id: 4,
    name: "Body Care",
    description: "Luxurious body care products",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1706780446658-33009956a676",
    altText: "Body care products manufacturing - body oils, shimmer oils, lotions India"
  },
  {
    id: 5,
    name: "Premium Imported Packaging",
    description: "High-quality packaging from China",
    icon: "Package",
    image: "https://images.unsplash.com/photo-1758788390320-16e1f280cf49",
    altText: "Premium cosmetic packaging solutions - imported beauty product containers from China"
  }
];

export const products = [
  {
    id: 1,
    name: "Lip & Cheek Tint",
    category: "Colour Cosmetics",
    shades: [
      { name: "Red chillies", color: "#DC143C" },
      { name: "Girlie pop", color: "#FF69B4" },
      { name: "Berrylicious", color: "#8B1874" },
      { name: "Peacy Pop", color: "#FFDAB9" },
      { name: "Emily in Paris pink shade", color: "#FF94B3" }
    ],
    shadeCount: "5 Shades",
    image: "https://images.unsplash.com/photo-1667242003851-e76e43823b8d",
    altText: "Lip and cheek tint manufacturing India - multi-use color cosmetics private label"
  },
  {
    id: 2,
    name: "Lip Gloss",
    category: "Colour Cosmetics",
    shades: [
      { name: "Pixie", color: "#FFB6C1" },
      { name: "Mocha", color: "#704214" },
      { name: "Berry pink", color: "#C71585" },
      { name: "Roasted chestnut", color: "#8B4513" },
      { name: "Honey", color: "#FFD700" },
      { name: "Taupe", color: "#8B7355" }
    ],
    shadeCount: "6 Shades",
    image: "https://images.unsplash.com/photo-1635263282145-253319c75fd4",
    altText: "Lip gloss manufacturing India - high shine glossy lip products private label"
  },
  {
    id: 3,
    name: "Lip Oils",
    category: "Colour Cosmetics",
    shadeCount: "6 Shades",
    description: "Nourishing lip oils with high-shine finish",
    image: "https://images.unsplash.com/photo-1697840526083-34c4367b79fa",
    altText: "Nourishing lip oil manufacturing - hydrating lip care products India"
  },
  {
    id: 4,
    name: "Liquid Lipstick",
    category: "Colour Cosmetics",
    shades: [
      { name: "Bon-bon", color: "#FFB6C1" },
      { name: "Eclair", color: "#D2691E" },
      { name: "Pink lemonade", color: "#FF6F91" },
      { name: "Plum", color: "#8E4585" },
      { name: "Toffee", color: "#A67B5B" },
      { name: "Toast", color: "#D2691E" },
      { name: "Buttercream", color: "#FFFACD" },
      { name: "Guava", color: "#FF6B9D" }
    ],
    shadeCount: "8 Shades",
    image: "https://images.unsplash.com/photo-1770981667014-677a0bf91663",
    altText: "Liquid lipstick manufacturing India - matte finish lip color private label cosmetics"
  },
  {
    id: 5,
    name: "Lip Balm",
    category: "Colour Cosmetics",
    shades: [
      { name: "Pink", color: "#FFB6C1" },
      { name: "Brown", color: "#8B4513" },
      { name: "Clear", color: "#FFFFFF" }
    ],
    shadeCount: "3 Shades",
    image: "https://images.unsplash.com/photo-1556228720-74787810a501",
    altText: "Lip balm manufacturing India - moisturizing lip care products third party production"
  },
  {
    id: 6,
    name: "Peel Off Lip Stain",
    category: "Colour Cosmetics",
    shades: [
      { name: "Pink", color: "#FF69B4" }
    ],
    shadeCount: "1 Shade",
    image: "https://images.unsplash.com/photo-1734077522356-d100054f28bc",
    altText: "Peel off lip stain manufacturing - long lasting lip color cosmetics India"
  },
  {
    id: 7,
    name: "Liquid Eyeliner",
    category: "Colour Cosmetics",
    description: "Precision tip for perfect winged liner",
    image: "https://images.unsplash.com/photo-1521840233161-295ed621e056",
    altText: "Liquid eyeliner manufacturing India - precision eye makeup cosmetics production"
  },
  {
    id: 8,
    name: "Hydrating Mist",
    category: "Skin Care",
    description: "Refreshing facial mist with hydrating benefits",
    image: "https://images.unsplash.com/photo-1618331911090-336dca45e7f0",
    altText: "Hydrating facial mist manufacturing - skincare spray products India"
  },
  {
    id: 9,
    name: "HOCL Spray",
    category: "Skin Care",
    description: "Hypochlorous acid spray for skin wellness",
    image: "https://images.unsplash.com/photo-1618331680655-5c23b9c4d29b",
    altText: "HOCL hypochlorous acid spray manufacturing - antibacterial skincare India"
  },
  {
    id: 10,
    name: "Body Oil",
    category: "Body Care",
    description: "Luxurious nourishing body oil blend",
    image: "https://images.unsplash.com/photo-1750085036915-6e21c6981586",
    altText: "Nourishing body oil manufacturing - luxury body care products India"
  },
  {
    id: 11,
    name: "Beard Growth Oil",
    category: "Hair Care",
    description: "Specially formulated for beard nourishment and growth",
    image: "https://images.unsplash.com/photo-1766101293873-41ef9c5f32b5",
    altText: "Beard growth oil manufacturing India - mens grooming products private label"
  },
  {
    id: 12,
    name: "Hair Serum",
    category: "Hair Care",
    description: "Smoothing and shine-enhancing hair serum",
    image: "https://images.unsplash.com/photo-1766101067640-b3ae41ba84bd",
    altText: "Hair serum manufacturing India - anti-frizz smoothing hair care products"
  },
  {
    id: 13,
    name: "Body Shimmer Oil",
    category: "Body Care",
    description: "Radiant shimmer oil for luminous skin",
    image: "https://images.unsplash.com/photo-1556227997-e90840afbf40",
    altText: "Body shimmer oil manufacturing - glitter body care cosmetics India"
  },
  {
    id: 14,
    name: "Eyeshadow",
    category: "Colour Cosmetics",
    shadeCount: "5 Shades",
    description: "Highly pigmented eyeshadow palette",
    image: "https://images.unsplash.com/photo-1625093525885-282384697917",
    altText: "Eyeshadow palette manufacturing India - pigmented eye makeup private label"
  },
  {
    id: 15,
    name: "Lip Liner",
    category: "Colour Cosmetics",
    shadeCount: "1 Shade",
    description: "Precise lip defining pencil",
    image: "https://images.unsplash.com/photo-1583746430595-8332fa43781c",
    altText: "Lip liner pencil manufacturing India - precision lip makeup cosmetics"
  }
];

export const aboutContent = {
  story: "VV CosmoTech Manufacturing, under the Vijan Ventures LLP umbrella, has been at the forefront of beauty and cosmetics manufacturing excellence. With years of expertise in formulation science and manufacturing processes, we provide comprehensive turnkey solutions for brands looking to launch or expand their beauty product lines.",
  mission: "To deliver world-class beauty manufacturing solutions that combine innovation, quality, and sustainability, empowering brands to succeed in the competitive cosmetics industry.",
  trustedBy: "Trusted by 50+ brands worldwide",
  workedWithRegions: ["India", "USA", "South Africa", "UAE"],
  capabilities: [
    {
      title: "Certified Manufacturing Facility",
      description: "Our manufacturing facility follows all international quality and safety standards, ensuring premium product quality."
    },
    {
      title: "Expert Team",
      description: "Our team of chemists, formulators, and quality control experts brings decades of combined experience."
    },
    {
      title: "Flexible MOQ",
      description: "We accommodate orders from small batches to large-scale production runs, supporting brands at every stage."
    },
    {
      title: "Fast Turnaround",
      description: "Efficient production processes ensure quick delivery without compromising on quality."
    }
  ]
};

export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Thank you for your inquiry! We'll get back to you within 24 hours." });
    }, 1000);
  });
};
